export default {_name:'divider',module:'Card/Form',view:'Element/Divider',options:{variant:'middle',orientation:'vertical',flexItem:true}}